import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TrackingPageModel } from 'app/core';

@Component({
  selector: 'app-tracking-page-search-form',
  templateUrl: './tracking-page-search-form.component.html'
})
export class TrackingPageSearchFormComponent implements OnInit {
  @Input() searchTitle: string = 'search_title';
  @Input() searchInputPlaceholder: string = 'search_input_placeholder';
  @Input() trackingPage: TrackingPageModel;
  @Input() selectedId: any;
  @Input() noNumbers: string | boolean;
  @Input() mode: any;
  @Input() isVisualBuilder: boolean;
  @Output() triggerSearchNumber = new EventEmitter();
  @Output() triggerBackToSearch = new EventEmitter();
  @Output() selectBlock = new EventEmitter();

  search: FormControl;

  constructor() {}

  ngOnInit(): void {
    this.search = new FormControl('');
  }

  searchNumber() {
    this.triggerSearchNumber.emit(this.search.value);
  }

  backToSearch() {
    this.search.setValue('', { emitEvent: false });
    this.triggerBackToSearch.emit();
  }

  get searchPageInputStyles() {
    const {
      borderRadius,
      borderWidth,
      borderColor,
      backgroundColor,
      shadow
    } = this.trackingPage.searchPageInput;
    return {
      boxShadow: shadow,
      borderColor,
      backgroundColor,
      'borderRadius.px': borderRadius,
      'borderWidth.px': borderWidth
    };
  }

  get trackButtonStyles() {
    const {
      borderRadius,
      borderWidth,
      borderColor,
      backgroundColor,
      shadow
    } = this.trackingPage.trackButton;
    return {
      backgroundColor,
      boxShadow: shadow,
      borderColor,
      'borderWidth.px': borderWidth,
      'borderRadius.px': borderRadius
    };
  }
}
